import { gtmEventType } from '@Components/Utilities/SandhillsConstants';
import { gtmPushEvent } from '@Components/Utilities/SandhillsUtility';
import { useWindowSize } from '@Components/Utilities/WindowSize';
import translator from '@Components/Utilities/Translator';

const ValueInsightPortalBanner = () => {

    const windowSize = useWindowSize();
    const vip = sandhills.TradeSites.React.ComponentProps['vip'];

    return (
        <>
            {vip &&
                <div className='vip-banner-cta' style={{ background: '#000 url(' + vip.VipPortalBackgroundImage + ') center center no-repeat' }}>
                    <div className='vip-details'>
                        {windowSize.isMobile &&
                            <div className='vip-img'>
                                <img src={vip.VipPortalLogoImage} alt='Value Insight Portal' />
                            </div>}
                        <p>
                            <strong>How much is your equipment worth?</strong><br />
                            All new VIP access has the answer!
                        </p>
                    </div>
                    <div className='vip-btn'>
                        {!windowSize.isMobile && <img src={vip.VipPortalLogoImage} alt='Value Insight Portal' />}
                        <a href={vip.VipPortalUrl} target='_blank' onClick={() => gtmPushEvent(gtmEventType.vip)} aria-label={"Unlock Free VIP Access (" + translator.translate('sandhills.opensinanewtab') + ")"}>
                            <i className='fas fa-unlock-alt' /> Unlock <span>Free</span> VIP Access
                        </a>
                    </div>
                </div>
            }
        </>
    );
};

export default ValueInsightPortalBanner;